import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "content-card-ui"
    }}>{`Content Card UI`}</h1>
    <h2 {...{
      "id": "requirements"
    }}>{`Requirements`}</h2>
    <ul>
      <li parentName="ul">{`Latest version of `}<a parentName="li" {...{
          "href": "https://developer.android.com/studio"
        }}>{`Android Studio`}</a></li>
      <li parentName="ul">{`Android API 21 (or newer)`}</li>
      <li parentName="ul">{`Kotlin 1.5.0 (or newer)`}</li>
      <li parentName="ul">{`App with support for `}<a parentName="li" {...{
          "href": "https://developer.android.com/develop/ui/compose/setup"
        }}>{`Jetpack Compose`}</a></li>
    </ul>
    <h2 {...{
      "id": "api-reference"
    }}>{`API Reference`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./api-usage.md"
        }}>{`Content Card APIs`}</a></li>
    </ul>
    <h2 {...{
      "id": "public-classes-enums-and-interfaces"
    }}>{`Public Classes, Enums, and Interfaces`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/aepui.md"
        }}>{`Interface - AepUI`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/contentcardmapper.md"
        }}>{`Class - ContentCardMapper`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/contentcarduieventlistener.md"
        }}>{`Interface - ContentCardUIEventListener`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/uiaction.md"
        }}>{`Class - UIAction`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/uievent.md"
        }}>{`Class - UIEvent`}</a></li>
    </ul>
    <h2 {...{
      "id": "content-provider"
    }}>{`Content Provider`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/content-provider/aepuicontentprovider.md"
        }}>{`AepUIContentProvider`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/content-provider/contentcarduiprovider.md"
        }}>{`ContentCardUIProvider`}</a></li>
    </ul>
    <h2 {...{
      "id": "observers"
    }}>{`Observers`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/observers/aepuieventobserver.md"
        }}>{`AepUIEventObserver`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/observers/contentcardeventobserver.md"
        }}>{`ContentCardEventObserver`}</a></li>
    </ul>
    <h2 {...{
      "id": "state"
    }}>{`State`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/state/aepcarduistate.md"
        }}>{`AepCardUIState`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/state/smallimagecarduistate.md"
        }}>{`SmallImageCardUIState`}</a></li>
    </ul>
    <h2 {...{
      "id": "styles"
    }}>{`Styles`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aepbuttonstyle.md"
        }}>{`AepButtonStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aepcardstyle.md"
        }}>{`AepCardStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aepcolumnstyle.md"
        }}>{`AepColumnStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aepiconstyle.md"
        }}>{`AepIconStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aepimagestyle.md"
        }}>{`AepImageStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aeprowstyle.md"
        }}>{`AepRowStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/aeptextstyle.md"
        }}>{`AepTextStyle`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/styles/smallimageuistyle.md"
        }}>{`SmallImageUIStyle`}</a></li>
    </ul>
    <h2 {...{
      "id": "ui-models"
    }}>{`UI Models`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/aepbutton.md"
        }}>{`AepButton`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/aepicon.md"
        }}>{`AepIcon`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/aepimage.md"
        }}>{`AepImage`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/aeptext.md"
        }}>{`AepText`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/aepuitemplate.md"
        }}>{`AepUITemplate`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/aepuitemplatetype.md"
        }}>{`AepUITemplateType`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./public-classes/ui-models/smallimagetemplate.md"
        }}>{`SmallImageTemplate`}</a></li>
    </ul>
    <h2 {...{
      "id": "tutorials"
    }}>{`Tutorials`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./tutorial/displaying-content-cards.md"
        }}>{`Fetch and Display Content Cards`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./tutorial/customizing-content-card-templates.md"
        }}>{`Customizing Content Card Templates`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./tutorial/listening-content-card-events.md"
        }}>{`Listening to Content Card Events`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      